module.exports = __webpack_public_path__ + "images/avg-rating-star-a7fc644a.svg";